import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { of } from 'rxjs';
import { first, catchError } from 'rxjs/operators';

import { Session } from '@model/session';
import { Event } from '@model/event';
import { AccountService } from '@app/_services/account.service';
import { EventService } from '../_services/event.service';
import { LoadingService } from '../_services/loading.service';
import { AlertService } from '../_services/alert.service';
import { FormatterService } from '../_services/formatter.service';
import { ReviewService } from '../_services/review.service';

declare let window: any;

@Component({
  selector: 'public-review',
  templateUrl: './public-review.component.html',
})
export class PublicReviewComponent implements OnInit {

  env = environment;
  formGlobalReview: FormGroup;
  loading = false;
  submitted = false;
  public selectedGlobalMark = 0;

  constructor( private http: HttpClient, public formatterService: FormatterService, private alertService: AlertService, private router: Router, public eventService: EventService, private route: ActivatedRoute, private loader: LoadingService, private formBuilder: FormBuilder, public accountService: AccountService, public reviewService: ReviewService )
  {
    this.formGlobalReview = this.formBuilder.group({
          comment: [''],
          rate: [''],
    });
  }

  ngOnInit() {
    let selectedId = parseInt(this.route.snapshot.paramMap.get('id')!);
  }

  //convenience getter for easy access to form fields
  get gf() { return this.formGlobalReview.controls; }

  onGlobalSubmit() {
		this.submitted = true;

		// stop here if form is invalid
		if (this.formGlobalReview.invalid) {
		   return;
		}

    let submitted = this.formGlobalReview.value;

    submitted.id = parseInt(this.route.snapshot.paramMap.get('id') || '' );
    submitted.hash = this.route.snapshot.paramMap.get('hash');

		this.loading = true;
    this.reviewService.sendPublicGlobalReview( submitted )
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.loading = false;
          this.alertService.success( data.message );
          this.router.navigate(['/']);
        },
        (err:any) => {

        	if( err.message )
        	{
	            this.alertService.error( err.message );
        	}
        	else
        	{
	            this.alertService.error('Une erreur est survenue');
        	}

            // hightlight des erreurs
            for( let i in err.errors )
            {
              let error = {};
              Object.defineProperty( error, err.errors[i].message, {
              	  value: true,
              	  writable: false
              } );

              this.gf[err.errors[i].property].setErrors( error );
            }

            this.loading = false;
        }
      );

  }

  changeGlobalMark(rate:any)
  {
  	this.gf['rate'].setValue(rate);
  	this.selectedGlobalMark = rate;
  }
}
